const linkLandingPagesValidationPT = {
    "add": {
        "title": {
            "required": "Título é obrigatório",
            "length": "O título não pode ter mais de 32 caracteres"
        },
        "short_description": {
            "length": "A descrição não pode ter mais de 80 caracteres."
        },
        "back_url": {
            "required": "URL de retorno é obrigatória",
            "length": "A URL de retorno não pode ter mais de 10 caracteres",
            "unique": "Ops! Esta URL de retorno já está associada a outra página de destino. Por favor, tente outra URL de retorno.",
            "available": "URL de retorno está disponível",
            "invalid": "URL de retorno é inválida"
        },
        "logo": {
            "required": "Logo é obrigatório",
            "dimensions": "O tamanho do logo deve ser no mínimo 500 X 500 px e a imagem deve ter proporção 1:1, formatos JPG/JPEG/PNG suportados.",
            "choose": "Por favor, escolha uma imagem",
            "file": "Por favor, carregue formatos JPG ou PNG, resolução mínima 500 X 500 px e imagem com proporção 1:1. Tamanho máximo 2MB"
        },
        "background_image": {
            "dimensions": "O tamanho da imagem de fundo deve ser no mínimo 1000 X 1000 px e a imagem deve ter proporção 1:1, formatos JPG/JPEG/PNG suportados.",
            "choose": "Por favor, escolha uma imagem",
            "file": "Por favor, carregue formatos JPG ou PNG, resolução mínima 1000 X 1000 px e imagem com proporção 1:1. Tamanho máximo 5MB"
        },
        "social_link_destination_url_facebook": {
            "required": "URL de destino é obrigatória",
            "regexp": "URL inválida",
            "invalid": "URL do Facebook inválida"
        },
        "social_link_destination_url_instagram": {
            "required": "URL de destino é obrigatória",
            "regexp": "URL inválida",
            "invalid": "URL do Instagram inválida"
        },
        "social_link_destination_url_twitter": {
            "required": "URL de destino é obrigatória",
            "regexp": "URL inválida",
            "invalid": "URL do Twitter inválida"
        },
        "social_link_destination_url_youtube": {
            "required": "URL de destino é obrigatória",
            "regexp": "URL inválida",
            "invalid": "URL do Youtube inválida"
        },
        "social_link_destination_url_tiktok": {
            "required": "URL de destino é obrigatória",
            "regexp": "URL inválida",
            "invalid": "URL do TikTok inválida"
        },
        "social_link_destination_url_linkedin": {
            "required": "URL de destino é obrigatória",
            "regexp": "URL inválida",
            "invalid": "URL do LinkedIn inválida"
        },
        "social_link_destination_url_other": {
            "regexp": "URL inválida"
        },
        "featured_link_title": {
            "required": "Rótulo é obrigatório",
            "length": "O rótulo não pode exceder 100 caracteres"
        },
        "featured_link_destination_url": {
            "required": "URL de destino é obrigatória",
            "regexp": "URL inválida"
        }
    },
    "update": {
        "title": {
            "required": "Título é obrigatório",
            "length": "O título não pode ter mais de 32 caracteres"
        },
        "short_description": {
            "length": "A descrição não pode ter mais de 80 caracteres."
        },
        "back_url": {
            "required": "URL de retorno é obrigatória",
            "length": "A URL de retorno não pode ter mais de 10 caracteres",
            "unique": "Ops! Esta URL de retorno já está associada a outra página de destino. Por favor, tente outra URL de retorno.",
            "available": "URL de retorno está disponível",
            "invalid": "URL de retorno é inválida"
        },
        "logo": {
            "required": "Logo é obrigatório",
            "dimensions": "O tamanho do logo deve ser no mínimo 500 X 500 px e a imagem deve ter proporção 1:1, formatos JPG/JPEG/PNG suportados.",
            "choose": "Por favor, escolha uma imagem",
            "file": "Por favor, carregue formatos JPG ou PNG, resolução mínima 500 X 500 px e imagem com proporção 1:1. Tamanho máximo 2MB"
        },
        "background_image": {
            "dimensions": "O tamanho da imagem de fundo deve ser no mínimo 1000 X 1000 px e a imagem deve ter proporção 1:1, formatos JPG/JPEG/PNG suportados.",
            "choose": "Por favor, escolha uma imagem",
            "file": "Por favor, carregue formatos JPG ou PNG, resolução mínima 1000 X 1000 px e imagem com proporção 1:1. Tamanho máximo 5MB"
        },
        "social_link_destination_url_facebook": {
            "required": "URL de destino é obrigatória",
            "regexp": "URL inválida",
            "invalid": "URL do Facebook inválida"
        },
        "social_link_destination_url_instagram": {
            "required": "URL de destino é obrigatória",
            "regexp": "URL inválida",
            "invalid": "URL do Instagram inválida"
        },
        "social_link_destination_url_twitter": {
            "required": "URL de destino é obrigatória",
            "regexp": "URL inválida",
            "invalid": "URL do Twitter inválida"
        },
        "social_link_destination_url_youtube": {
            "required": "URL de destino é obrigatória",
            "regexp": "URL inválida",
            "invalid": "URL do Youtube inválida"
        },
        "social_link_destination_url_tiktok": {
            "required": "URL de destino é obrigatória",
            "regexp": "URL inválida",
            "invalid": "URL do TikTok inválida"
        },
        "social_link_destination_url_linkedin": {
            "required": "URL de destino é obrigatória",
            "regexp": "URL inválida",
            "invalid": "URL do LinkedIn inválida"
        },
        "social_link_destination_url_other": {
            "regexp": "URL inválida"
        },
        "featured_link_title": {
            "required": "Rótulo é obrigatório",
            "length": "O rótulo não pode exceder 100 caracteres"
        },
        "featured_link_destination_url": {
            "required": "URL de destino é obrigatória",
            "regexp": "URL inválida"
        }
    }
};

export default linkLandingPagesValidationPT;